// data from http://www.thesauruslex.com/typo/eng/enghtml.htm
const charactersInLanguage = {
  es: "áéíóñúüªº¡¿",
  sv: "åäö",
  fr: "àâçèéêëîïôœùûüÿ",
  fi: "äö",
  nl: "éëó",
  da: "æøå",
  it: "àâèéêìíîïòôùû",
  de: "äöüß",
  ca: "àçèéíïòóúü",
  pl: "ąćęłńóśźż",
  pt: "àáâãçèéêìíïòóõùúüªº",
  sr: "абвгдђежзијклљмнњопрстћуфхцчџш",
  ru: "абвгдеёжзийклмнопрстуфхцчшщъыьэюя",
  ro: "ăâîşţ",
  cz: "áčďéěíňóřšťúůýž",
  el: "αβγδεζηθικλμνξοπρσςτυφχψω",
  tr: "çğıöşü",
  sl: "čšž",
  is: "áðéíóúýþæö",
  no: "æøå",
  sk: "áäčďéíĺľňóôŕšťúýž",
  hr: "ćčđšž",
  bg: "абвгдежзийклмнопрстуфхцчшщъьюя",
  ga: "áéíóú",
};

// adapted from http://stackoverflow.com/questions/1064089/inserting-a-text-where-cursor-is-using-javascript-jquery
const insertAtCaret = function (txtarea, text) {
  const scrollPos = txtarea.scrollTop;
  let strPos = 0;
  const br =
    txtarea.selectionStart || txtarea.selectionStart == "0"
      ? "ff"
      : // @ts-ignore
        document.selection
        ? "ie"
        : false;
  let range;
  if (br == "ie") {
    txtarea.focus();
    // @ts-ignore
    range = document.selection.createRange();
    range.moveStart("character", -txtarea.value.length);
    strPos = range.text.length;
  } else if (br == "ff") strPos = txtarea.selectionStart;

  const front = txtarea.value.substring(0, strPos);
  const back = txtarea.value.substring(strPos, txtarea.value.length);
  txtarea.value = front + text + back;
  strPos = strPos + text.length;
  if (br == "ie") {
    txtarea.focus();
    // @ts-ignore
    range = document.selection.createRange();
    range.moveStart("character", -txtarea.value.length);
    range.moveStart("character", strPos);
    range.moveEnd("character", 0);
    range.select();
  } else if (br == "ff") {
    txtarea.selectionStart = strPos;
    txtarea.selectionEnd = strPos;
    txtarea.focus();
  }
  txtarea.scrollTop = scrollPos;
  txtarea.dispatchEvent(new Event("input", { bubbles: true }));
};

const Button = ({ getInputElement, character, disabled }) => (
  <button
    onClick={() => insertAtCaret(getInputElement(), character)}
    disabled={disabled}
  >
    {character}
  </button>
);

const AccentInputView = ({ getInputElement, language, disabled }) => {
  const characters = charactersInLanguage[language];

  return (
    <div class="accentInputPanel">
      {characters &&
        characters
          .split("")
          .map((character) => (
            <Button
              getInputElement={getInputElement}
              character={character}
              disabled={disabled}
            />
          ))}
    </div>
  );
};

export default AccentInputView;
